import { render, staticRenderFns } from "./BaseShippingCompanies.vue?vue&type=template&id=bc433020&"
import script from "./BaseShippingCompanies.vue?vue&type=script&lang=ts&"
export * from "./BaseShippingCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports